export default __webpack_public_path__ + "static/media/noimage02.924d9f4e.svg";